import moment from 'moment/moment';
import numeral from 'numeral';
import { getFormattedAmount } from '@bbkPricingPage/lib/currencies';

export class NumberKit {
  public static formatNumber = (value: number): string =>
    numeral(value).format('0,0');

  public static formatNumberPrecision1 = (value: number): string =>
    numeral(value).format('0,0.0');

  public static formatMoney = (value: number): string =>
    numeral(value).format('$0,0');

  public static formatMoneyPrecision1 = (value: number): string =>
    numeral(value).format('$0,0.0');

  public static formatPercent = (percent: number | string): string =>
    `${numeral(percent).format('0.0')}%`;

  public static formatToFixed = (number: number): string =>
    `${numeral(number).format('0.0')}`;

  public static formatMoneyWithCents = (
    value: number,
    currencyCode = 'USD',
    fractionDigits: number = 2
  ): string => {
    const currency = currencyCode.trim().toUpperCase() || 'USD';
    const fd =
      Number.isFinite(fractionDigits) &&
      fractionDigits >= 0 &&
      fractionDigits <= 20
        ? Math.trunc(fractionDigits)
        : 2;

    try {
      return getFormattedAmount(value, currency, fd);
    } catch {
      const decimalPart = fd > 0 ? `.${'0'.repeat(fd)}` : '';
      if (currency === 'USD') {
        return numeral(value).format(`$0,0${decimalPart}`);
      }

      return `${currency} ${numeral(value).format(`0,0${decimalPart}`)}`;
    }
  };

  public static formatMoneySignificantDigits = (value: number): string => {
    const absValue = Math.abs(value);
    const sign = value >= 0 ? '' : '-';

    if (absValue < 1000) {
      return `${sign}$${absValue.toFixed(0)}`;
    } else if (absValue < 1000000) {
      // Thousands: show 1 decimal, truncate .0
      const kValue = absValue / 1000;
      const formatted = kValue.toFixed(1).replace(/\.0$/, '');
      return `${sign}$${formatted}K`;
    } else {
      // Millions: show 1 decimal, truncate .0
      const mValue = absValue / 1000000;
      const formatted = mValue.toFixed(1).replace(/\.0$/, '');
      return `${sign}$${formatted}M`;
    }
  };

  public static formatDate = (dateToFormat: unknown) => {
    if (!dateToFormat) return '--';
    return moment(dateToFormat).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: 'MMM D',
      lastDay: '[Yesterday]',
      lastWeek: 'MMM D',
      sameElse: 'MMM D',
    });
  };
}
